import { html, css } from 'lit-element';
import { BaseElement } from './BaseElement';
import { API, EVENT_TYPES } from '../API';
import { Account } from '../Account';
import { DIALOG_TYPE_ERROR } from './ModalDialog';
import { PhysicianPortalEventTypes as _PhysicianPortalEventTypes } from '../PhysicianPortalEventTypes';
import * as GUID from '../GUID';

import './PhysicianPortalEventType';

const _types = Symbol();
const _api = Symbol();
const _account = Symbol();
const _statusHandler = Symbol();

class PhysicianPortalEventTypes extends BaseElement {
	constructor() {
		super();

		this[_statusHandler] = () => {
			if(this.api.loggedIn && !this.types && this.api.isPhysician)
				this.getTypes();
			else if(!this.api.loggedIn)
				this.types = null;
			this.requestUpdate();
		};
	}
	static get styles() {
		return [
			...BaseElement.styles,
			css`
				:host {
					display: block;
				}
				fieldset {
					// margin: 0.5em;
				}
				legend {
					padding: 0 0.5em;
					border-bottom: none;
					font-weight: bold;
				}
			`
		];
	}
	get api() {
		return this[_api];
	}
	set api(v) {
		if(v !== null && !(v instanceof API))
			throw new TypeError('api must be an instance of API.');
		this[_api] = v;
	}
	get types() {
		return this[_types];
	}
	set types(v) {
		if(v !== null && !(v instanceof _PhysicianPortalEventTypes))
			throw new TypeError('types must be an instance of PhysicianPortalEventTypes.');
		this[_types] = v;
		this.requestUpdate();
	}
	get account() {
		return this[_account];
	}
	set account(v) {
		if(v !== null && !(v instanceof Account))
			throw new TypeError('account must be an instsnce of Account.');
		this[_account] = v;
		this.requestUpdate();
	}
	async getTypes() {
		const id = GUID.newGUID();
		try {
			this.emit('show-busy', id);
			if(!this.api)
				throw new Error('no api set.');
			this.types = await this.api.physicianPortalEventTypes();
			const ids = await this.api.doctorPhysicianPortalEventTypeIds();
			[...this.shadowRoot.querySelectorAll('pp-event-type')].forEach(v => {
				v.checked = ids.indexOf(v.type.PhysicianPortalEventTypeId) >= 0;
			});
			this.emit('hide-busy', id);
		}
		catch(err) {
			this.emit('hide-busy', id);
			this.emit('show-dialog', {
				title: 'Physician Event Types',
				message: err.message,
				type: DIALOG_TYPE_ERROR
			});
		}
	}

	async checkHandler(e) {
		try {
			const { type, checked } = e.target;

			if(checked)
				await this.api.addPhysicianPortalEvent(type.PhysicianPortalEventTypeId);
			else
				await this.api.removePhysicianPortalEvent(type.PhysicianPortalEventTypeId);
		}
		catch(err) {
			this.emit('show-dialog', {
				title: 'Event Type Error',
				message: err.message,
				type: DIALOG_TYPE_ERROR
			});
		}
	}
	connectedCallback() {
		super.connectedCallback();

		this.emit('get-api', { callback: api => this.api = api });
		this.emit('get-account', { callback: account => this.account = account });

		this.api.on(EVENT_TYPES.EVENT_TYPE_LOGIN_STATUS, this[_statusHandler]);
		this.account.on('load', this[_statusHandler]);

		if(this.api.loggedIn && this.api.isPhysician)
			this.getTypes();
	}
	disconnectedCallback() {
		super.disconnectedCallback();

		this.api.off(null, this[_statusHandler]);
		this.account.off(null, this[_statusHandler]);

		this.api = null;
		this.account = null;
	}
	render() {
		return html`
			<fieldset>
				<legend>Event Types</legend>
				<p class="info">
					<i class="icon fas fa-info-circle"></i>
					Select the event types you would like to be notified of by email.
					${
						(this.account && this.account.appServerAlertsEmail) ?
							html`Alerts are dispatched to <em><strong>${this.account.appServerAlertsEmail}</strong></em> as soon as information becomes available.` :
							html`If you would like to leverage this feature, please contact  <a href="mailto:TechSupport@kinexmedical.com?subject=Physician Portal Alerts Email Request">Kinex Tech Support (techsupport@kinexmedical.com)</a>.`
					}
				</p>
				${this.types ? [...this.types].map(v => html`
					<pp-event-type @check="${(e) => this.checkHandler(e)}" .type="${v}"></pp-event-type>
				`) : ''}
			</fieldset>
		`;
	}
}

customElements.define('pp-event-types', PhysicianPortalEventTypes);